export default "__VITE_ASSET__CDhUH5DK__"